<template>
  <div>
    <div class="md-layout" v-for="row in testingValuesDialog" :key="row.key">
      <label class="md-layout-item md-xsmall-size-25 md-size-15 md-form-label">{{row.name}}</label>

      <div
        v-for="item in row.keys"
        :key="item.key"
        class="md-layout-item md-xsmall-size-25 md-size-10 mx-auto"
      >
        <md-checkbox
          class="md-primary"
          v-model="settings.conditions"
          :value="item.key"
          :name="item.key"
          v-validate="modelValidations.checkbox"
        >{{item.name}}</md-checkbox>
      </div>

      <div class="md-layout-item md-size-15 mx-auto">
        <md-field :class="[{ 'md-error': errors.has(row.key) }]">
          <label>{{$lang.inputs.accuracy}}</label>
          <md-input
            class="accuracy-field"
            v-model="settings.accuracy[row.key]"
            :name="row.key"
            type="text"
            v-validate="modelValidations.accuracy"
            :disabled="disabledInput(row.key)"
          ></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has(row.key)">close</md-icon>
          </slide-y-down-transition>

          <span class="md-form-label suffix-label">%</span>
        </md-field>
      </div>
    </div>

    <div class="md-layout">
      <div class="md-layout-item md-xsmall-size-25 md-size-20 ml-auto">
        <md-checkbox
          class="md-primary"
          v-model="selectAllTestConditionsValue"
        >{{$lang.inputs.select_all}}</md-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    SlideYDownTransition
  },
  props: {
    settings: {
      type: Object,
      default() {
        return {
          conditions: [],
          accuracy: {
            U: "",
            I: "",
            P: "",
            Q: "",
            S: ""
          }
        };
      }
    }
  },
  data() {
    return {
      modelValidations: {
        accuracy: {
          required: true,
          regex: /^[0-9.]+$/,
          max_value: 100,
          min_value: 0.000000000000001
        },
        checkbox: {
          required: true,
          included: [
            "VA",
            "VB",
            "VC",
            "IA",
            "IB",
            "IC",
            "PA",
            "PB",
            "PC",
            "QA",
            "QB",
            "QC",
            "SA",
            "SB",
            "SC"
          ]
        }
      },

      selectAllTestConditionsValue: false,
      testingValuesDialog: [
        {
          name: this.$lang.menu.voltage,
          key: "U",
          keys: [
            {
              name: "L1",
              key: "VA"
            },
            {
              name: "L2",
              key: "VB"
            },
            {
              name: "L3",
              key: "VC"
            }
          ]
        },
        {
          name: this.$lang.menu.current,
          key: "I",
          keys: [
            {
              name: "L1",
              key: "IA"
            },
            {
              name: "L2",
              key: "IB"
            },
            {
              name: "L3",
              key: "IC"
            }
          ]
        },
        {
          name: this.$lang.menu.active_power,
          key: "P",
          keys: [
            {
              name: "L1",
              key: "PA"
            },
            {
              name: "L2",
              key: "PB"
            },
            {
              name: "L3",
              key: "PC"
            }
          ]
        },
        {
          name: this.$lang.menu.reactive_power,
          key: "Q",
          keys: [
            {
              name: "L1",
              key: "QA"
            },
            {
              name: "L2",
              key: "QB"
            },
            {
              name: "L3",
              key: "QC"
            }
          ]
        },
        {
          name: this.$lang.menu.apparent_power,
          key: "S",
          keys: [
            {
              name: "L1",
              key: "SA"
            },
            {
              name: "L2",
              key: "SB"
            },
            {
              name: "L3",
              key: "SC"
            }
          ]
        }
      ]
    };
  },

  watch: {
    "settings.conditions"(newVal, oldVal) {
      if (newVal.length === this.modelValidations.checkbox.included.length) {
        this.selectAllTestConditionsValue = true;
      } else {
        this.selectAllTestConditionsValue = false;
      }
    },
    selectAllTestConditionsValue(newVal, oldVal) {
      if (newVal === true) {
        this.settings.conditions = [...this.modelValidations.checkbox.included];
      } else {
        if (
          this.settings.conditions.length ===
          this.modelValidations.checkbox.included.length
        ) {
          this.settings.conditions = [];
        }
      }
    }
  },

  methods: {
    disabledInput(key) {
      if (key === "U"){
        key = "V";
      }
      if (this.settings.conditions.findIndex(el => el.charAt(0) == key) != -1){
        return false;
      }
      return true;      
    },
    
    validate() {
      return this.$validator.validateAll().then(res => {
        if (res) {
          this.$emit(
            "on-validated",
            true,
            {
              conditions: this.settings.conditions,
              accuracy: this.settings.accuracy
            },
            true
          );
        }
        return res;
      });
    }
  }
};
</script>

<style scoped>
.accuracy-field {
  min-width: 10px;
}
</style>